import type {ReactElement} from 'react';
import React, {useState} from 'react';
import styles from './download-yotpo-section.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {GA4EventName, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';

export function DownloadYotpoSection(): ReactElement {
  const [isHovered, setIsHovered] = useState(false);

  const onClickGoogleCta = (): void => {
    trackPosterBuilderGA4Events(GA4EventName.POST_DOWNLOAD_OPTIONS, {[GA4EventParamName.TYPE]: 'Play store'});
  };
  const onClickYoutubeCta = (): void => {
    trackPosterBuilderGA4Events(GA4EventName.POST_DOWNLOAD_OPTIONS, {[GA4EventParamName.TYPE]: 'Youtube'});
  };
  const onClickAppleCta = (): void => {
    trackPosterBuilderGA4Events(GA4EventName.POST_DOWNLOAD_OPTIONS, {[GA4EventParamName.TYPE]: 'Apple store'});
  };

  return (
    <div className={`_full-width spacing-p-t-4 spacing-m-t-4 ${styles.container} flex-v-row`}>
      <div className="_full-width flex-center">
        <div
          className={`flex-v-row flex-items-center _cursor-pointer _fit-width ${styles.imgContainer} spacing-m-b-4`}
          onMouseEnter={(): void => {
            setIsHovered(true);
          }}
          onMouseLeave={(): void => {
            setIsHovered(false);
          }}
          onClick={(): void => {
            window.open(window.PMW.util.site_url('reviews'), '_blank');
          }}
        >
          <img className={styles.yotpoImg} src={getAssetUrl('yotpo_modern_logo.webp')} alt="yotpo" />
          <div className={`${styles.starsContainer} flex-h-row`}>
            <Icon className={styles.ratingStar} icon="icon-star" size={IconSize.SIZE_ICON_16} />
            <Icon className={styles.ratingStar} icon="icon-star" size={IconSize.SIZE_ICON_16} />
            <Icon className={styles.ratingStar} icon="icon-star" size={IconSize.SIZE_ICON_16} />
            <Icon className={styles.ratingStar} icon="icon-star" size={IconSize.SIZE_ICON_16} />
            <Icon className={styles.ratingStarLast} icon="icon-star" size={IconSize.SIZE_ICON_16} />
          </div>
          {isHovered ? (
            <Text val={window.i18next.t('pmwjs_read_all_reviews')} size={TextSize.XXXSMALL} className="content-link" />
          ) : (
            <Text val="4.8 / 5 (840)" size={TextSize.XXXSMALL} className="content-body" />
          )}
        </div>
      </div>

      <div className={`flex-h-row justify-content-between gap-2 ${styles.buttonsContainer}`}>
        <a onClick={onClickGoogleCta} href="https://play.google.com/store/apps/details?id=com.app.postermywall12&hl=en" target="_blank" className="flexbox">
          <img loading="lazy" alt="Google Play Button" src={getAssetUrl('download-google-play-button.webp')} />
        </a>
        <a onClick={onClickAppleCta} href="https://apps.apple.com/pk/app/postermywall-design-promote/id6469032454" target="_blank" className="flexbox">
          <img loading="lazy" alt="App Store Button" src={getAssetUrl('download-apple-store-button.webp')} />
        </a>
        <a onClick={onClickYoutubeCta} href="https://www.youtube.com/c/postermywall" target="_blank" className="flexbox">
          <img loading="lazy" alt="Google Play Button" src={getAssetUrl('download-youtube-button.webp')} />
        </a>
      </div>
    </div>
  );
}
